import { APIServices } from './axiosCommon';

export interface MachineDto {
  uid: number;
  id: string | null;
  machineType: string;
  locationId: number | null;
  location: { uid: number; name: string | null; timezone: string | null } | null;
}

export const machinesApi = {
  list: () => APIServices.get<{ success: boolean; data: MachineDto[] }>('/machines'),
};
